// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__Fyr-e","main-content":"Layout_main-content__dl7EK","nav-hide":"Layout_nav-hide__ooMTp"};